import { Link } from 'react-router-dom'
import { useI18n } from '@runtime/core/i18n/i18n'
import { homeDestinations } from '@/routes/home/homeDestinations'
import { trackHomeTileClick } from '@/routes/home/homeMetrics'
import detective from '@/routes/home/assets/home-tile-rules.png'
import pieces from '../assets/workshop-pieces.png'
import assemble from '../assets/workshop-assemble.png'
import universe from '../assets/universe-hokusai.png'
import styles from './HomeResources.module.scss'
export default function HomeResources() {
  const { t, locale } = useI18n()
  const destinations = homeDestinations(locale)
  return (
    <section className={styles.resources} aria-label={t('home.exploreTitle')}>
      <article className={styles.learn}>
        <Link
          className={styles.learnLink}
          to="/rules"
          data-testid="home-tile-rules"
          onClick={() => trackHomeTileClick('rules', '/rules')}
        >
          <div>
            <small aria-hidden="true">01 /</small>
            <h2>{t('home.welcome.learn')}</h2>
            <p>{t('home.welcome.learnDesc')}</p>
            <span className={styles.cta}>
              {t('learn.homeAction')} <b aria-hidden="true">→</b>
            </span>
          </div>
          <img src={detective} alt="" loading="lazy" />
        </Link>
        <Link
          className={styles.education}
          to="/education"
          data-testid="home-tile-education"
          onClick={() => trackHomeTileClick('education', '/education')}
        >
          {t('common.playNavigation.education')} <span aria-hidden="true">→</span>
        </Link>
      </article>
      <a
        className={styles.workshops}
        href={destinations.workshops}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="home-workshops"
        onClick={() => trackHomeTileClick('workshops', destinations.workshops)}
      >
        <div>
          <small aria-hidden="true">02 /</small>
          <h2>{t('home.welcome.workshops')}</h2>
          <p>{t('home.welcome.workshopsDesc')}</p>
          {destinations.fallback && <small>{t('home.welcome.frenchSite')}</small>}
          <span className={styles.cta}>
            {t('home.welcome.workshops')} <b aria-hidden="true">↗</b>
          </span>
        </div>
        <figure aria-hidden="true">
          <img src={assemble} alt="" loading="lazy" />
          <img src={pieces} alt="" loading="lazy" />
        </figure>
      </a>
      <a
        className={styles.universe}
        href={destinations.universe}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="home-discover"
        onClick={() => trackHomeTileClick('discover', destinations.universe)}
      >
        <div>
          <small aria-hidden="true">03 /</small>
          <h2>{t('home.welcome.discover')}</h2>
          <p>{t('home.welcome.discoverDesc')}</p>
          {destinations.fallback && <small>{t('home.welcome.frenchSite')}</small>}
          <span className={styles.cta}>
            {t('home.welcome.discover')} <b aria-hidden="true">↗</b>
          </span>
        </div>
        <img src={universe} alt="" loading="lazy" />
      </a>
    </section>
  )
}
